var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "sidebar-collapse": _vm.isSidebarCollapsed,
        "sidebar-open": !_vm.isSidebarCollapsed
      }
    },
    [
      _c("Sidebar", {
        attrs: { isSidebarCollapsed: _vm.isSidebarCollapsed },
        on: {
          sidebarCollapsed: function($event) {
            _vm.isSidebarCollapsed = true
          }
        }
      }),
      _c("div", { staticClass: "top-header" }, [
        _c("div", { staticClass: "container-head" }, [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.isSidebarCollapsed = !_vm.isSidebarCollapsed
                }
              }
            },
            [
              _c("img", {
                staticClass: "hamburger",
                attrs: { src: "/img/Dashboard/Navigation_icon.png" }
              })
            ]
          ),
          _vm.routeName == "dashboard"
            ? _c("span", [_vm._v("\n                DASHBOARD\n            ")])
            : _vm._e(),
          _vm.routeName == "brand"
            ? _c("span", [
                _vm._v("\n                BRAND\n                "),
                _c(
                  "button",
                  {
                    staticClass: "header-action",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#brandpopup"
                    }
                  },
                  [_vm._v("BRAND")]
                )
              ])
            : _vm._e(),
          _vm.routeName == "store"
            ? _c("span", [
                _vm._v("\n                STORE\n                "),
                _c(
                  "button",
                  {
                    staticClass: "header-action",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#storelocationpopup"
                    }
                  },
                  [_vm._v("STORE")]
                )
              ])
            : _vm._e(),
          _vm.routeName == "picklr"
            ? _c("span", [_vm._v("\n                PICKLR\n            ")])
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "below-header" }, [
        _c("div", { staticClass: "container-main" }, [
          _c(
            "div",
            { staticClass: "out-padd container-inner bg-pickl" },
            [
              _c("div", {
                staticClass: "container-overlay",
                on: {
                  click: function($event) {
                    _vm.isSidebarCollapsed = true
                  }
                }
              }),
              _c("router-view")
            ],
            1
          )
        ])
      ]),
      _c("BrandPopup", { attrs: { popupId: "brandpopup" } }),
      _c("StoreLocationPopup", { attrs: { popupId: "storelocationpopup" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }